import React from "react"
import ModalCommonTemplate from "components/Modal/ModalCommonTemplate"
import ModalUnsupportedCar from "components/Modal/ModalUnsupportedCar"
import ModalConfirmation from "components/Modal/ModalConfirmation"
import ModalCondListBefore from "./ModalCondListBefore"
import { ModalRead } from "./ModalCommonRead"
import ModalWithChild from "./ModalWithChild"
import {
  accessaryDiscount,
  bicycleDamage,
  EV_HV,
  familyBike,
  forYourCarOriginalPriceComp,
  forYourCarReplacementCar,
  forYourCarTotalLossComp,
  forYourCarType,
  liveTogether,
  servant,
  gradeCondition,
  lawyerCost,
  objectTotalLossBefore,
  objectTotalLoss,
  otherCarDriving,
  paper,
  passengerInjury,
  personalAndObject,
  personalInjury,
  personalLiability,
  roadAssistance,
  uninsuredCarAccidents,
  victimSaving,
  internetDiscount,
  secondCar,
  earlyPaymentDiscountThirtyDays,
  earlyPaymentDiscountFiftyDays,
  ALSOK,
  newCarDiscount,
  ASVDiscount,
  GoldLicenseDiscount,
  Grade20NoClaimDiscount,
  NoAccidentDiscount
} from "./child/PlanBodyText"
import ModalCondList from "./ModalCondList"

export const MODAL_TYPE = {
  IMPOSSIBLE: "impossible",
  CONFIRMATION: "confirmation",
  LICENSE: "license",
  PURPOSE: "purpose",
  TRANSFER: "transfer",
  LIVE_TOGETHER: "liveTogether",
  SERVANT: "servant",
  NON_FLEET: "nonfleet",
  YOUNGEST_AGE: "youngestAge",
  GRADE_CONDITION: "gradeCondition",
  PERSONAL_AND_OBJECT: "personalAndObject",
  UNINSURED_CAR_ACCIDENTS: "uninsuredCarAccidents",
  VICTIM_SAVING: "victimSaving",
  OTHER_CAR_DRIVING: "otherCarDriving",
  EV_HV: "EV_HV",
  PERSONAL_INJURY: "personalInjury",
  PASSENGER_INJURY: "passengerInjury",
  OBJECT_TOTAL_LOSS_BEFORE: "objectTotalLossBefore",
  OBJECT_TOTAL_LOSS: "objectTotalLoss",
  ROAD_ASSISTANCE: "roadAssistance",
  LAWYER_COST: "lawyerCost",
  PERSONAL_LIABILITY: "personalLiability",
  BICYCLE_DAMAGE: "bicycleDamage",
  ACCESSARY_DISCOUNT: "accessaryDiscount",
  PAPER: "paper",
  FAMILY_BIKE: "familyBike",
  FOR_YOUR_CAR__TYPE: "forYourCar_type",
  FOR_YOUR_CAR__TOTAL_LOSS_COMPENSATION: "forYourCar_totalLossComp",
  FOR_YOUR_CAR__ORIGINAL_PRICE_COMPENSATION: "forYourCar_originalPriceComp",
  FOR_YOUR_CAR__REPLACEMENT_CAR: "forYourCar_replacementCar",
  CONDITION_LIST_BEFORE: "condListBefore",
  CONDITION_LIST: "condList",
  INTERNET_DISCOUNT: "internetDiscount",
  SECOND_CAR: "secondCar",
  EARLY_PAYMENT_DISCOUNT_THIRTY_DAYS: "earlyPaymentDiscountThirtyDays",
  EARLY_PAYMENT_DISCOUNT_FIFTY_DAYS: "earlyPaymentDiscountFiftyDays",
  ALSOK: "ALSOK",
  NEW_CAR_DISCOUNT: "newCarDiscount",
  ASV_DISCOUNT: "ASVDiscount",
  GOLD_LICENSE_DISCOUNT: "GoldLicenseDiscount",
  GRADE_20_NO_CLAIM_DISCOUNT: "Grade20NoClaimDiscount",
  DRIVER_RANGE_SELECTION: "driverRangeSelection",
  NO_ACCIDENT_DISCOUNT: "NoAccidentDiscount"
}
/**
 * ヘルプボタン（？）押下時に表示するモーダルを選択する（LayoutWithModalコンポーネントと合わせて使用）
 * @param {string} contentsType - 表示するモーダル種別
 * @return {ReactNode} - モーダルコンポーネントを返す
 */
export const modalSelector = (contentsType: string) => {
  let modal = <ModalCommonTemplate />
  const read =
    "説明文を記載してください。説明文を記載してください。説明文を記載してください。説明文を記載してください。説明文を記載してください。説明文を記載してください。"
  switch (contentsType) {
    // Top page
    case MODAL_TYPE.IMPOSSIBLE:
      modal = ModalUnsupportedCar()
      break
    // Result page
    case MODAL_TYPE.CONFIRMATION:
      modal = <ModalConfirmation />
      break
    // Condition page
    case MODAL_TYPE.LICENSE:
      modal = (
        <ModalCommonTemplate
          title={ModalRead.license.title}
          read1={ModalRead.license.read1}
          read2={ModalRead.license.read2}
          url={ModalRead.license.url}
        />
      )
      break
    case MODAL_TYPE.PURPOSE:
      modal = (
        <ModalCommonTemplate
          title={ModalRead.purpose.title}
          read1={ModalRead.purpose.read1}
          url={ModalRead.purpose.url}
        />
      )
      break
    case MODAL_TYPE.TRANSFER:
      modal = (
        <ModalCommonTemplate
          title={ModalRead.transfer.title}
          read1={ModalRead.transfer.read1}
          url={ModalRead.transfer.url}
        />
      )
      break
    case MODAL_TYPE.LIVE_TOGETHER:
      modal = <ModalWithChild title="同居のお子さま" child={liveTogether()} />
      break
    case MODAL_TYPE.SERVANT:
      modal = <ModalWithChild title="使用人の方" child={servant()} />
      break
    case MODAL_TYPE.NON_FLEET:
      modal = (
        <ModalCommonTemplate
          title={ModalRead.nonfleet.title}
          read1={ModalRead.nonfleet.read1}
          url={ModalRead.nonfleet.url}
        />
      )
      break
    case MODAL_TYPE.GRADE_CONDITION:
      modal = <ModalWithChild title="７S等級（複数所有新規）になる条件は？" child={gradeCondition()} />
      break
    case MODAL_TYPE.PERSONAL_AND_OBJECT:
      modal = <ModalWithChild title="対人・対物賠償" child={personalAndObject()} />
      break
    case MODAL_TYPE.UNINSURED_CAR_ACCIDENTS:
      modal = <ModalWithChild title="無保険車傷害" child={uninsuredCarAccidents()} />
      break
    case MODAL_TYPE.VICTIM_SAVING:
      modal = <ModalWithChild title="被害者救済費用特約" child={victimSaving()} />
      break
    case MODAL_TYPE.OTHER_CAR_DRIVING:
      modal = <ModalWithChild title="他車運転特約" child={otherCarDriving()} />
      break
    case MODAL_TYPE.EV_HV:
      modal = <ModalWithChild title="電気・ハイブリッド車割引" child={EV_HV()} />
      break
    case MODAL_TYPE.PERSONAL_INJURY:
      modal = <ModalWithChild title="人身傷害" child={personalInjury()} />
      break
    case MODAL_TYPE.PASSENGER_INJURY:
      modal = <ModalWithChild title="搭乗者傷害" child={passengerInjury()} />
      break
    case MODAL_TYPE.OBJECT_TOTAL_LOSS_BEFORE:
      modal = <ModalWithChild title="対物全損時修理差額費用特約" child={objectTotalLossBefore()} />
      break
    case MODAL_TYPE.OBJECT_TOTAL_LOSS:
      modal = <ModalWithChild title="対物全損時修理差額費用特約" child={objectTotalLoss()} />
      break
    case MODAL_TYPE.ROAD_ASSISTANCE:
      modal = <ModalWithChild title="ロードアシスタンス特約" child={roadAssistance()} />
      break
    case MODAL_TYPE.LAWYER_COST:
      modal = <ModalWithChild title="弁護士費用特約" child={lawyerCost()} />
      break
    case MODAL_TYPE.PERSONAL_LIABILITY:
      modal = <ModalWithChild title="個人賠償責任特約" child={personalLiability()} />
      break
    case MODAL_TYPE.BICYCLE_DAMAGE:
      modal = <ModalWithChild title="自転車傷害特約" child={bicycleDamage()} />
      break
    case MODAL_TYPE.ACCESSARY_DISCOUNT:
      modal = <ModalWithChild title="車両身の回り品補償" child={accessaryDiscount()} />
      break
    case MODAL_TYPE.PAPER:
      modal = <ModalWithChild title="デジタル保険証券" child={paper()} />
      break
    case MODAL_TYPE.FAMILY_BIKE:
      modal = <ModalWithChild title="ファミリーバイク特約" child={familyBike()} />
      break
    case MODAL_TYPE.FOR_YOUR_CAR__TYPE:
      modal = <ModalWithChild title="車両保険" child={forYourCarType()} />
      break
    case MODAL_TYPE.FOR_YOUR_CAR__TOTAL_LOSS_COMPENSATION:
      modal = <ModalWithChild title="車両全損修理時特約" child={forYourCarTotalLossComp()} />
      break
    case MODAL_TYPE.FOR_YOUR_CAR__ORIGINAL_PRICE_COMPENSATION:
      modal = <ModalWithChild title="車両新価特約" child={forYourCarOriginalPriceComp()} />
      break
    case MODAL_TYPE.FOR_YOUR_CAR__REPLACEMENT_CAR:
      modal = <ModalWithChild title="事故時代車費用特約" child={forYourCarReplacementCar()} />
      break
    case MODAL_TYPE.INTERNET_DISCOUNT:
      modal = <ModalWithChild title="ネット割" child={internetDiscount()} />
      break
    case MODAL_TYPE.SECOND_CAR:
      modal = <ModalWithChild title="おとなの2台目割引" child={secondCar()} />
      break
    case MODAL_TYPE.EARLY_PAYMENT_DISCOUNT_THIRTY_DAYS:
      modal = <ModalWithChild title="早割30日" child={earlyPaymentDiscountThirtyDays()} />
      break
    case MODAL_TYPE.EARLY_PAYMENT_DISCOUNT_FIFTY_DAYS:
      modal = <ModalWithChild title="早割50日" child={earlyPaymentDiscountFiftyDays()} />
      break
    case MODAL_TYPE.ALSOK:
      modal = <ModalWithChild title="ALSOK事故現場安心サポート" child={ALSOK()} />
      break
    case MODAL_TYPE.NEW_CAR_DISCOUNT:
      modal = <ModalWithChild title="新車割引" child={newCarDiscount()} />
      break
    case MODAL_TYPE.ASV_DISCOUNT:
      modal = <ModalWithChild title="自動ブレーキ（ASV）割引" child={ASVDiscount()} />
      break
    case MODAL_TYPE.GOLD_LICENSE_DISCOUNT:
      modal = (
        <ModalWithChild
          title="ゴールド免許割引
      "
          child={GoldLicenseDiscount()}
        />
      )
      break
    case MODAL_TYPE.GRADE_20_NO_CLAIM_DISCOUNT:
      modal = <ModalWithChild title="20等級継続割引" child={Grade20NoClaimDiscount()} />
      break
    case MODAL_TYPE.CONDITION_LIST_BEFORE:
      modal = <ModalCondListBefore />
      break
    case MODAL_TYPE.CONDITION_LIST:
      modal = <ModalCondList />
      break
    case MODAL_TYPE.DRIVER_RANGE_SELECTION:
      modal = (
        <ModalCommonTemplate
          title={ModalRead.driverRangeSelection.title}
          read1={ModalRead.driverRangeSelection.read1}
          url={ModalRead.driverRangeSelection.url}
        />
      )
      break
    case MODAL_TYPE.NO_ACCIDENT_DISCOUNT:
      modal = <ModalWithChild title="無事故割引" child={NoAccidentDiscount()} />
      break
    default:
      modal = <ModalCommonTemplate />
  }
  return modal
}
